// src/notifications/services/use-reset-notification-seen.ts
// POST /api/Notifications/ResetNotificationSeenCount — zero the unseen badge.
//
// Mirrors Flutter `resetUnSeenNotificationsCount`
// (notification_center_data_source_impl.dart:56-64) and the bloc's
// `ResetNotificationSeenCountEvent`, which the notification screen fires on open
// (initState) and which drives the badge to 0. No request body (source sends
// none). On success we optimistically set the cached count to 0 so the bell
// clears immediately, then invalidate to reconcile with the server.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import { useAuthStore } from '@/auth/auth-store';
import {
  unseenNotificationCountQueryKey,
  unseenNotificationCountKey,
} from './use-unseen-notification-count';

export function useResetNotificationSeen() {
  const queryClient = useQueryClient();
  const userId = useAuthStore((s) => s.user?.userId);
  return useMutation({
    mutationFn: () => post<unknown>('/api/Notifications/ResetNotificationSeenCount', undefined),
    onSuccess: () => {
      // Optimistically zero THIS user's cached count (per-user key), then
      // invalidate the prefix to reconcile with the server.
      queryClient.setQueryData<number>(unseenNotificationCountKey(userId), 0);
      queryClient.invalidateQueries({ queryKey: unseenNotificationCountQueryKey });
    },
  });
}
